interface FeatureCardProps {
  icon: React.ReactNode;
  iconBgColor: string;
  iconColor: string;
  title: string;
  description: string;
}

export default function FeatureCard({ icon, iconBgColor, iconColor, title, description }: FeatureCardProps) {
  return (
    <div className="text-center pb-8 md:pb-0 max-w-sm mx-auto">
      <div className="flex justify-center mb-4">
        <div className={`${iconBgColor} ${iconColor} p-3 rounded-full`}>
          {icon}
        </div>
      </div>
      <h3 className="font-semibold mb-2 text-gray-900 text-lg font-serif">{title}</h3>
      <p className="text-lg md:text-md text-gray-600 px-6 md:px-0">
        {description}
      </p>
    </div>
  );
}
